module.exports = __webpack_public_path__ + "static/media/theater2.a6a2bfd8.png";